import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import { RequestNetworkError } from '../core/RequestError';
import axios from 'axios';
import queryString from '../utils/queryString';
import { checkMock } from '../middlewares/mock';

function makeUrl(url, data) {
  var searchStr = queryString(data);
  var urlHasSeach = url.indexOf('?') >= 0;
  return urlHasSeach ? "".concat(url, "&").concat(searchStr) : "".concat(url, "?").concat(searchStr);
}

export default function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$useTimestamp = _ref.useTimestamp,
      useTimestamp = _ref$useTimestamp === void 0 ? true : _ref$useTimestamp,
      _ref$withCredentials = _ref.withCredentials,
      withCredentials = _ref$withCredentials === void 0 ? true : _ref$withCredentials;

  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var data, reqUrl, config;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!checkMock(this)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            data = Object.assign({
              otype: 'xjson'
            }, this.request.data, useTimestamp ? {
              _st: Date.now()
            } : {});
            reqUrl = makeUrl(this.request.url, data);
            config = Object.assign({
              method: 'get',
              url: reqUrl,
              withCredentials: withCredentials
            }, this.request.options);
            _context.next = 7;
            return axios(config).then(function (response) {
              return response.data;
            })["catch"](function (error) {
              console.error(error);

              if (error.response) {
                throw new RequestNetworkError('网络开小差了！请重试', error.response.status, error.response.data);
              } else {
                throw new RequestNetworkError();
              } // @todo 网络返回超时！请重试

            });

          case 7:
            this.response = _context.sent;

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
}